$(function () {
  $year = $("#user_form_birthday_1i");
  $month = $("#user_form_birthday_2i");
  $day = $("#user_form_birthday_3i");
  default_date = "1";

  $("#user_form_birthday_1i, #user_form_birthday_2i").on("change", function () {
    year = parseInt($year.val());
    month = parseInt($month.val());
    day = parseInt($day.val());
    days = new Date(year, month, 0).getDate();
    changeDayOptions(days);
    if (day > days) {
      $day.val(default_date);
    }
  });
});

changeDayOptions = function(days_in_month) {
  [29, 30, 31].forEach(e => {
    if (e > days_in_month) {
      $('#user_form_birthday_3i option[value="'+ e +'"]').hide();
    } else {
      $('#user_form_birthday_3i option[value="'+ e +'"]').show();
    }
  })
}
